import { Home, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
      <div className="max-w-2xl w-full text-center space-y-8">
        <div className="relative">
          <h1 className="text-[12rem] font-black text-slate-200 select-none leading-none">
            404
          </h1>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="bg-white/80 backdrop-blur-sm p-4 px-6 rounded-2xl shadow-xl border border-slate-100">
              <p className="text-2xl font-bold text-slate-900">
                Oops! Page not found
              </p>
            </div>
          </div>
        </div>

        <div className="space-y-3">
          <h2 className="text-xl text-slate-600 max-w-md mx-auto leading-relaxed">
            The page you are looking for doesn't exist or has been moved.
          </h2>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
          <Button
            variant="default"
            size="lg"
            className="bg-blue-600 hover:bg-blue-700 text-white px-8 h-12 rounded-xl shadow-lg shadow-blue-200 transition-all active:scale-95 w-full sm:w-auto"
            onClick={() => (window.location.href = "/")}
          >
            <Home className="mr-2 h-5 w-5" />
            Back to Home
          </Button>

          <Button
            variant="outline"
            size="lg"
            className="bg-white border-slate-200 text-slate-600 px-8 h-12 rounded-xl hover:bg-slate-50 transition-all active:scale-95 w-full sm:w-auto"
            onClick={() => window.history.back()}
          >
            <ArrowLeft className="mr-2 h-5 w-5" />
            Go Back
          </Button>
        </div>
      </div>
    </div>
  );
}
